import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TableLazyLoadEvent } from 'primeng/table';
import { StatusWorkflowControllerGetStatusWorkflows$Params } from 'src/app/api/fn/status-workflow/status-workflow-controller-get-status-workflows';
import { StatusWorkflowItem } from 'src/app/api/models';
import { StatusWorkflowService } from 'src/app/api/services';
import { enumWorkflowType } from 'src/app/utils/models/workflow.model';

@Component({
  selector: 'app-modal-workflow-picker',
  templateUrl: './modal-workflow-picker.component.html',
  styleUrls: ['./modal-workflow-picker.component.scss'],
})
export class ModalWorkflowPickerComponent {
  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];
  constructor(
    public ref: DynamicDialogRef,
    private workflowService: StatusWorkflowService,
    private messageService: MessageService,
    public dialogService: DialogService,
    public config: DynamicDialogConfig
  ) {
    this.tipoWF = config.data.tipo;
  }

  availableWorkflows: StatusWorkflowItem[] = [];
  selectedWorkflow?: StatusWorkflowItem;
  totalRecords = 0;
  loading = false;
  tipoWF?: 'ticket' | 'ordine_cliente' | 'ordine_fornitore' | 'ordine' | 'consegna';

  ngOnInit() {
    if (this.tipoWF) {
      this.getWorkflows(this.tipoWF, undefined);
    }
  }

  getWorkflows(tipo: string, event?: TableLazyLoadEvent) {
    const params: StatusWorkflowControllerGetStatusWorkflows$Params = {};
    this.loading = true;
    if (tipo === 'ticket') {
      params.type_id = enumWorkflowType.TICKET;
    }
    if (tipo === 'ordine_cliente') {
      params.type_id = enumWorkflowType.CUSTOMER_ORDER;
    }
    if (tipo === 'ordine_fornitore') {
      params.type_id = enumWorkflowType.ORDER;
    }
    if (tipo === 'ordine') {
      params.type_id = undefined;
    }
    if (tipo === 'consegna') {
      params.type_id = enumWorkflowType.DELIVERY;
    }

    if (event) {
      // Paginazione
      params.skip = event.first ?? undefined;
      params.limit = event.rows ?? undefined;

      // // Filtri
      if (event.filters) {
        const filters = event.filters;
        const globalFilter = filters['global'];

        //   if (filters['name']?.value) {
        //     params.name = filters['name'].value;
        //   }

        //   if (filters['created_on_from']?.value) {
        //     params.created_on_from = filters['created_on_from'].value;
        //   }

        //   if (filters['created_on_to']?.value) {
        //     params.created_on_to = filters['created_on_to'].value;
        //   }

        //   if (filters['updated_on_from']?.value) {
        //     params.updated_on_from = filters['updated_on_from'].value;
        //   }

        //   if (filters['updated_on_to']?.value) {
        //     params.updated_on_to = filters['updated_on_to'].value;
        //   }

        if (globalFilter) {
          if (!Array.isArray(globalFilter)) {
            params.query = globalFilter.value;
          } else if (globalFilter.length > 0) {
            params.query = globalFilter[0].value;
          }
        }
      }
    }

    this.workflowService.statusWorkflowControllerGetStatusWorkflows(params).subscribe({
      next: res => {
        this.loading = false;
        this.availableWorkflows = res.data.list;
        this.totalRecords = res.data.count;
      },
      error: err => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Errore recupero workflows',
          detail: err.error?.message || 'Errore sconosciuto',
        });
      },
    });
  }

  close() {
    this.ref.close();
  }

  save() {
    // this.ref.close(this.selectedWorkflow);
    const result = {
      workflow: this.selectedWorkflow,
      tipo: this.tipoWF,
    };
    this.ref.close(result);
  }
}
